export default {
  Calculations: {
    HEADING: 'Calculations',
    SINGLE_HEADING: 'Calculation for {{month}}',
    POSTINGS: 'Postings',
    NEW: '+ New',
    NO_RULES:
      'No recharge rules have been defined for this group. Go to the Groups page to set some up',
    BROKEN_RULES:
      'One or more rules are misconfigured. Please check the Rules page before continuing',
    Table: {
      NO_INVOICE: 'No postings have been made for this period yet',
      VIEW_POSTINGS: 'View postings',
      DELETE: 'Delete calculation',
      REVIEW_RECHARGES: 'Review recharges',
      REVIEW_TRANSACTIONS: 'Review Transactions',
      REVIEW_POSTINGS: 'Review Postings',
      HAS_NEW:
        'This calculation has had new transactions since it was locked, so some of its postings need updating',
    },
    Create: {
      TITLE: 'Create new Calculation',
      MESSAGE:
        "Choose the period you'd like to run the calculation for. Note: Calculations can take some time to run, so please be patient!",
      MONTH: 'Month',
      ERROR:
        'There was an error generating your calculation, please try again or report to the Mayday team',
      CREATE: 'Create',
      OVERLAP:
        'Error: you cannot select a range that overlaps with an existing calculation.',
      UPGRADE: 'Custom recharge periods are not available in your subscription',
    },
    Delete: {
      TITLE: 'Delete Calculation',
      BODY: 'Are you sure you want to remove the {{period}} calculation ?',
    },
    Operations: {
      LOCK: 'Mark as Final',
      LOCKED: 'Marked as Final',
      UNLOCK: 'Re-open',
      RECALCULATE: 'Recalculate',
      LOCKED_ON: 'Locked on {{date}}',
      RECALC_POPUP:
        'Use the "Sync with Xero" button on the left to make sure any new or updated transactions and in Recharger before recalculating.',
      LOCK_POPUP:
        'Marking as final will freeze the calculation so it cannot be edited. The calculation can be re-opened at any time.',
      LOCK_DISABLED:
        'Postings for the current period cannot be marked as final.',
      UNLOCK_POPUP:
        'Re-opening will allow you to edit the calculation or recalculate to bring in new transactions.',
      PREVIOUSLY_LOCKED: 'This calculation was previously marked as final.',
      LOCKED_DATE: 'This calculation was first marked as final on {{date}}.',
      UNLOCKED_NOTICE:
        'It will use the configuration of rules and apportionments as they were on that date. If you need to use the latest rules, please delete and re-create this calculation.',
      LOCKED_NEW_TRANSACTIONS:
        'Since this calculation was marked as final, new transactions have been entered which affect the recharges. Re-open the calculation to see these transactions and update Xero.',
      Lock: {
        TITLE: 'Mark calculation for {{month}} as final?',
        BODY: 'Marking the calculation as final will do the following:',
        PT_1: 'Lock the version of rules used to calculate the recharges.',
        PT_11:
          "This means any updates to rules you make after the first time you mark this calculation as final won't be applied to transactions from this period.",
        PT_2: 'Create an audit trail.',
        PT_21:
          "The calculation can be re-opened at any time, but each time it's marked as final the full calculation will be recorded for auditing.",
        PT_3: 'Disable auto re-calculating.',
        PT_31:
          "This means any transactions which are added or changed while the calculation is marked as final won't be included until the calculation is re-opened.",
        PT_32:
          "Note: we currently don't notify you if a calculation should be re-opened.",
        BODY_2: 'The calculation can be re-opened at any point',
      },
    },
    Loading: {
      CREATING: 'Running the calculation',
      RECALCULATING: 'Recalculating',
      TIME: "This shouldn't take more than a minute",
      DID_YOU_KNOW: 'Did you know...',
      FACTS: [
        'The term Mayday comes from the French "m\'aider" or "m\'aidez", meaning "help me".',
        'According to the rules of radio communications, "Mayday" has to be repeated three times when declaring an emergency.',
        '"Mayday" was invented in the 1920s at Croydon Airport, as most of the air traffic at the time was between Croydon and Le Bourget Airport, Paris.',
        'Before "Mayday" came to be used, the universal distress call was the Morse code for "SOS", deemed unsuitable for use over voice communications.',
        'Another common distress call is "pan-pan", from the French "panne" meaning "breakdown". This is used for other emergencies such as technical failure or medical incidents.',
        'The similar call "Seelonce mayday" (after the French for "silence") prioritises exchanges between the vessel in distress and authorities.',
        'Unlike other radio communication terms like "alpha" and "bravo", "mayday" isn\'t part of the phonetic alphabet.',
        'The earliest recorded form of accounting dates back to ancient Mesopotamia, where accountants used clay tablets to record financial transactions.',
        'Luca Pacioli, an Italian mathematician, is often referred to as the "Father of Accounting.", having written "Summa de Arithmetica, Geometria, Proportioni et Proportionalita" in 1494, in which included a section on double-entry bookkeeping.',
        'The ancient Egyptians used hieroglyphics to record financial transactions on papyrus scrolls, providing evidence of income and expenses related to agricultural and economic activities.',
        'Roman accountants used a process called "adversaria" to record financial data in a chronological order.',
        "May Day, also known as International Workers' Day or Labour Day, is celebrated on the 1st of May each year in many countries around the world.",
        'One of the traditional customs associated with May Day is maypole dancing during which participants, often dressed in colorful attire, dance around a tall pole, weaving ribbons in intricate patterns.',
        'Actress Grace Jones received a Best Supporting Actress nomination at the 1985 Saturn Awards for her role as May Day in the James Bond film "A View To Kill".',
        'Flowers have long been associated with May Day. In medieval England, people would gather flowers and greenery to decorate their homes and villages. This practice is connected to the celebration of spring and the blossoming of flowers.',
        'In medieval England, May Day was often celebrated with Robin Hood games and plays. These events included archery contests, theatrical performances, and other festivities.',
      ],
    },
  },
};
